import { render, staticRenderFns } from "./CampaignIntegrationMatchFormBindings.vue?vue&type=template&id=163fee53&scoped=true&"
import script from "./CampaignIntegrationMatchFormBindings.vue?vue&type=script&lang=js&"
export * from "./CampaignIntegrationMatchFormBindings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163fee53",
  null
  
)

export default component.exports